import './picturefill';



// WEBPACK FOOTER //
// ../shared/polyfills/index.js